import certifyApi from '../../api/certify.api'
const state = {}
const getters = {}
const mutations = {}
const actions = {
	// 获取认证信息
	findCertifyByUserId(context, data) {
		return certifyApi.findCertifyByUserId(data)
	},
	// 个人认证
	perCertify(context, data) {
		return certifyApi.perCertify(data)
	},
	// 企业认证
	entCertify(context, data) {
		return certifyApi.entCertify(data)
	}
}

export default { state, getters, mutations, actions, namespaced: true}
